module.exports = __webpack_public_path__ + "img/S19THs.fae30b59.png";